import { network } from 'services/network';

export const getProgramGeneralHierarchyList = () => {
    return network.get('api/bo/project/getProgramGeneralHierarchyList').then((response) => {
        return response.data;
    });
};
